import classNames from "classnames";
import AppleFeaturedCategoryCard from "@components/ShopInShop/Apple/AppleFeaturedCategoryCard";

const AppleFeaturedCategoriesList = ({ categories, onProductClick }) => (
  <ul>
    {categories.map((category, index) => (
      <li
        key={category.slug}
        className={classNames({
          "pt-[16px] mt-[16px] border-t border-[#EBEBEB]": index !== 0,
        })}
      >
        <AppleFeaturedCategoryCard
          index={index}
          category={category}
          onProductClick={onProductClick}
        />
      </li>
    ))}
  </ul>
);

export default AppleFeaturedCategoriesList;
